import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ElementActions, ElementTypes, GaContext, GlobalBookingTripDates, TripType } from '@fcom/common';
import { ButtonTheme } from '@fcom/ui-components/components/buttons/button/enums';
import { IconButtonSize, IconButtonTheme } from '@fcom/ui-components/components/buttons/icon-button/enums';
import { GtmService } from '@fcom/common/gtm/services/gtm.service';
import { PriceCalendarType } from '@fcom/common/components/price-calendar/price-calendar.component';

import { LocationParam } from '../../interfaces/location-pair.interface';
import { BookingWidgetService } from '../../services/booking-widget.service';
import { BookingWidgetFlightService } from '../../services/booking-widget-flight.service';

@Component({
  selector: 'fin-multicity-selector',
  templateUrl: './multicity-selector.component.html',
  styleUrls: ['./multicity-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MulticitySelectorComponent {
  private bookingWidgetService = inject(BookingWidgetService);
  private bookingWidgetFlightService = inject(BookingWidgetFlightService);
  private gtmService = inject(GtmService);

  readonly ButtonTheme = ButtonTheme;
  readonly IconButtonTheme = IconButtonTheme;
  readonly IconButtonSize = IconButtonSize;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly PriceCalendarType = PriceCalendarType;
  readonly TripType = TripType;

  protected readonly flights = this.bookingWidgetFlightService.flights;

  setLocations({ locations }: LocationParam, index?: number): void {
    this.bookingWidgetFlightService.setLocations(locations, index);
  }

  setTravelDates(dates: GlobalBookingTripDates, index: number, isAirCalendar = false): void {
    this.bookingWidgetService.setTravelDates(dates, index, isAirCalendar, false);
  }

  setFlexibleDates(isFlexibleDates: boolean): void {
    this.bookingWidgetService.setFlexibleDates(isFlexibleDates);
  }

  addFlight(index: number): void {
    this.bookingWidgetFlightService.addFlight();
    this.gtmService.trackElement(
      'multicity-add-bound',
      GaContext.BOOKING_FLOW,
      ElementTypes.BUTTON,
      String(index),
      ElementActions.CLICK
    );
  }

  removeFlight(index: number): void {
    this.bookingWidgetFlightService.removeFlight(index);
    this.gtmService.trackElement(
      'multicity-remove-bound',
      GaContext.BOOKING_FLOW,
      ElementTypes.BUTTON,
      String(index + 1),
      ElementActions.CLICK
    );
  }
}
